import { render } from "./StaffLayout.vue?vue&type=template&id=21b584a2"
import script from "./StaffLayout.vue?vue&type=script&lang=js"
export * from "./StaffLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__